import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV4() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1168">
      <HeroSection data-id="element-1169" />
      <PainSection data-id="element-1170" />
      <TruthSection data-id="element-1171" />
      <ProductPresentation data-id="element-1172" />
      <ContentBreakdown data-id="element-1173" />
      <BenefitsSection data-id="element-1174" />
      <TestimonialsSection data-id="element-1175" />
      <ForYouSection data-id="element-1176" />
      <GuaranteeSection data-id="element-1177" />
      <BonusSection data-id="element-1178" />
      <ValueStack basePrice={18.9} popupStrikethroughPrice="$30.88 USD" popupSpecialPrice="$27.29 USD" data-id="element-1179" />
      <FAQSection data-id="element-1180" />
      <ImpactPhrases data-id="element-1181" />
      <Footer data-id="element-1182" />
    </div>;
}